import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VisaDesignerService } from '../visa-designer.service';
//import { VisaDesignerService } from 'src/app/services/visa-designer.service';

@Component({
  selector: 'app-vd-letters-elements',
  templateUrl: './vd-letters-elements.component.html',
  styleUrls: ['./vd-letters-elements.component.scss']
})
export class VdLettersElementsComponent implements OnInit {
  @Output() onMovetoSource: EventEmitter<any> = new EventEmitter();
  @ViewChild('f', { static: false }) templateForm: NgForm;
  defaultElementList = [];
  selectedElementList = [];
  observableSubscription$ = new Subject();
  visaInfo: any;
  formChangesSubscription: Subscription;
  visaId: string;
  isEditVisa:boolean = false;
  

  constructor(private vdService: VisaDesignerService, private toastr: ToastrService, private router: Router,
    private route: ActivatedRoute, protected store: Store<any>,) { }

  ngOnInit(): void {
    this.visaId = localStorage.getItem('visaId');
    this.vdService.getVisaById(this.visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.visaInfo = response.data;
       this.getElementList();
        this.selectedElementList = response.data && response.data.tmpltPlcHldrJson ? JSON.parse(response.data.tmpltPlcHldrJson) : [];
    });
    // this.vdService.getVisaInfo.subscribe((response) => {
    //   console.log("elements summary view response", response);
    //   this.visaInfo = response;
    //   this.getElementList();
    //   this.selectedElementList = response.tmpltPlcHldrJson ? JSON.parse(response.tmpltPlcHldrJson) : [];
    //   // console.log("filter changed",response, this.requestPayload);
    // });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }
  getElementList() {
    const taskType = 'PETITION';
    const taskTypeId = this.visaInfo.visaId;
    this.vdService.getAllPlaceHolderList(taskType, taskTypeId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      console.log("visa info", response);
      this.defaultElementList = response.data ? response.data : [];


    });
  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.templateForm.statusChanges.subscribe(() => {
      if (this.templateForm.dirty) {
        this.store.dispatch(new MarkDirtyFormAction({
          dirty: true
        }));
      }
      else {
        this.store.dispatch(new MarkCleanFormAction({
          dirty: false
        }));
      }
    });
  }

  selectedCatagory(event: any) {
    //  console.log("selected catagory", event);
    //Remove duplicate elements in the array
    const selectedElements = [... this.selectedElementList]; // Some array I got from async call
    this.selectedElementList = Array.from(new Set(selectedElements.map(a => a.name)))
      .map(name => {
        return selectedElements.find(a => a.name === name)
      });
    // console.log("result", this.selectedElementList);

  }

  handleSaveStep() {
    console.log("save", this.visaInfo);
    let payload: any = {};
    try {

      payload.visaId = this.visaInfo && this.visaInfo.visaId ? this.visaInfo.visaId : 0;
      payload.tmpltPlcHldrJson = JSON.stringify(this.selectedElementList);
    } catch (error) {
      console.log("error", error);

    }

    console.log("save 2", payload);
    this.vdService.createVisa(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      console.log("create task", response);
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        // this.resetForm();
        if (response.data) {
          // this.router.navigate([`../../visa-details-steps/${response.data}`], { relativeTo: this.route });
        }

      }
    });

  }
  handleGoback() {
    this.router.navigate([`../../generate-letters`], { relativeTo: this.route });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    if (this.formChangesSubscription) {
      this.formChangesSubscription.unsubscribe();
    }
    this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
  }

}
